import { render, staticRenderFns } from "./NotesWithLatest.vue?vue&type=template&id=0de3694a&scoped=true&"
import script from "./NotesWithLatest.vue?vue&type=script&lang=js&"
export * from "./NotesWithLatest.vue?vue&type=script&lang=js&"
import style0 from "./NotesWithLatest.vue?vue&type=style&index=0&id=0de3694a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de3694a",
  null
  
)

export default component.exports